import { Controller } from "@hotwired/stimulus"

// Pairs a <input type="range"> with a text node that mirrors its value as
// the user drags. The optional `data-suffix` attribute on the input adds a
// trailing unit (e.g. "hr") to the readout. `data-zero-label` overrides the
// readout when the value is 0 (e.g. "gig"). Markup:
//
//   <div data-controller="range-with-readout">
//     <span data-range-with-readout-target="readout">5 hr</span>
//     <input type="range" min="1" max="8" step="1"
//            data-range-with-readout-target="input" data-suffix="hr">
//   </div>
export default class extends Controller<HTMLElement> {
  static targets = [ "input", "readout" ]

  declare readonly inputTarget:   HTMLInputElement
  declare readonly readoutTarget: HTMLElement

  connect() {
    this.inputTarget.addEventListener("input", this.sync)
    this.sync()
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.sync)
  }

  private sync = () => {
    const { suffix, zeroLabel } = this.inputTarget.dataset
    const value = this.inputTarget.value
    if (zeroLabel && Number(value) === 0) {
      this.readoutTarget.textContent = zeroLabel
      return
    }
    this.readoutTarget.textContent = suffix ? `${value} ${suffix}` : value
  }
}
